import svgToTinyDataUri from '../svg-to-mini-data-uri';

const shareMyScreenIconSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="1" y="2" width="14" height="10" rx="1" stroke="var(--stroke-0, #2B2A35)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5 14H11" stroke="var(--stroke-0, #2B2A35)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M8 5V9M8 5L6 7M8 5L10 7" stroke="var(--stroke-0, #2B2A35)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export const shareMyScreenIcon = svgToTinyDataUri(shareMyScreenIconSvg);
